"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _CaseNew = _interopRequireDefault(require("../model/CaseNew"));

var _CaseResp = _interopRequireDefault(require("../model/CaseResp"));

var _CaseUpdateRequest = _interopRequireDefault(require("../model/CaseUpdateRequest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Case service.
* @module api/CaseApi
* @version 1.0.0
*/
var CaseApi = /*#__PURE__*/function () {
  /**
  * Constructs a new CaseApi. 
  * @alias module:api/CaseApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function CaseApi(apiClient) {
    _classCallCheck(this, CaseApi);

    this.apiClient = apiClient || _ApiClient.default.instance;
  }
  /**
   * list specific case
   * @param {Number} caseId Case id
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CaseResp} and HTTP response
   */


  _createClass(CaseApi, [{
    key: "apiV1CasesCaseIdGetWithHttpInfo",
    value: function apiV1CasesCaseIdGetWithHttpInfo(caseId) {
      var postBody = null; // verify the required parameter 'caseId' is set

      if (caseId === undefined || caseId === null) {
        throw new Error("Missing the required parameter 'caseId' when calling apiV1CasesCaseIdGet");
      }

      var pathParams = {
        'case_id': caseId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _CaseResp.default;
      return this.apiClient.callApi('/api/v1/cases/{case_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * list specific case
     * @param {Number} caseId Case id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CaseResp}
     */

  }, {
    key: "apiV1CasesCaseIdGet",
    value: function apiV1CasesCaseIdGet(caseId) {
      return this.apiV1CasesCaseIdGetWithHttpInfo(caseId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * update case
     * @param {Number} caseId Case id
     * @param {Object} opts Optional parameters
     * @param {module:model/CaseUpdateRequest} opts.caseUpdateRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1CasesCaseIdPatchWithHttpInfo",
    value: function apiV1CasesCaseIdPatchWithHttpInfo(caseId, opts) {
      opts = opts || {};
      var postBody = opts['caseUpdateRequest']; // verify the required parameter 'caseId' is set

      if (caseId === undefined || caseId === null) {
        throw new Error("Missing the required parameter 'caseId' when calling apiV1CasesCaseIdPatch");
      }

      var pathParams = {
        'case_id': caseId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/cases/{case_id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * update case
     * @param {Number} caseId Case id
     * @param {Object} opts Optional parameters
     * @param {module:model/CaseUpdateRequest} opts.caseUpdateRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1CasesCaseIdPatch",
    value: function apiV1CasesCaseIdPatch(caseId, opts) {
      return this.apiV1CasesCaseIdPatchWithHttpInfo(caseId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * update case
     * @param {Number} caseId Case id
     * @param {Object} opts Optional parameters
     * @param {module:model/CaseUpdateRequest} opts.caseUpdateRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1CasesCaseIdPutWithHttpInfo",
    value: function apiV1CasesCaseIdPutWithHttpInfo(caseId, opts) {
      opts = opts || {};
      var postBody = opts['caseUpdateRequest']; // verify the required parameter 'caseId' is set

      if (caseId === undefined || caseId === null) {
        throw new Error("Missing the required parameter 'caseId' when calling apiV1CasesCaseIdPut");
      }

      var pathParams = {
        'case_id': caseId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/cases/{case_id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * update case
     * @param {Number} caseId Case id
     * @param {Object} opts Optional parameters
     * @param {module:model/CaseUpdateRequest} opts.caseUpdateRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1CasesCaseIdPut",
    value: function apiV1CasesCaseIdPut(caseId, opts) {
      return this.apiV1CasesCaseIdPutWithHttpInfo(caseId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * list cases
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/CaseResp>} and HTTP response
     */

  }, {
    key: "apiV1CasesGetWithHttpInfo",
    value: function apiV1CasesGetWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'page': opts['page']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_CaseResp.default];
      return this.apiClient.callApi('/api/v1/cases', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * list cases
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/CaseResp>}
     */

  }, {
    key: "apiV1CasesGet",
    value: function apiV1CasesGet(opts) {
      return this.apiV1CasesGetWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * create case
     * @param {Object} opts Optional parameters
     * @param {module:model/CaseNew} opts.caseNew 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CaseResp} and HTTP response
     */

  }, {
    key: "apiV1CasesPostWithHttpInfo",
    value: function apiV1CasesPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['caseNew'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _CaseResp.default;
      return this.apiClient.callApi('/api/v1/cases', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * create case
     * @param {Object} opts Optional parameters
     * @param {module:model/CaseNew} opts.caseNew 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CaseResp}
     */

  }, {
    key: "apiV1CasesPost",
    value: function apiV1CasesPost(opts) {
      return this.apiV1CasesPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return CaseApi;
}();

exports.default = CaseApi;